// import { LoadGif } from 'components'
import { MouseEvent } from 'react'
import {
  logoSmall,
  logoSmallBlack,
  logoSmallWhite,
  loading,
} from 'assets/Icons'
import Button from './style'

interface IButtonProps {
  border?: boolean
  small?: boolean
  disabled?: boolean
  children: JSX.Element[] | JSX.Element | string
  onClick?: (_e: MouseEvent<HTMLElement>) => void
  $loading?: boolean | string
  icon?: any
  secondary?: boolean
  tertiary?: boolean
  style?: any
  type?: 'button' | 'submit' | 'reset'
  height?: number
  big?: boolean
  id?: string
  xsmall?: boolean
  orange?: boolean
}

export default function DefaultButton(props: IButtonProps) {
  const {
    $loading,
    children,
    icon,
    secondary,
    tertiary,
    type,
    xsmall,
    orange,
  } = props

  const getLoad = () => {
    if (secondary) {
      return loading
    }
    if (tertiary) {
      return loading
    }
    return loading
  }

  return (
    <Button {...props} icon={icon} type={type}>
      {icon ? (
        <img className="default-btn-img" src={icon} alt="select icon" />
      ) : null}
      {!$loading && children}
      {$loading && (
        <img className="loading-img-button" src={getLoad()} alt="card icon" />
      )}
    </Button>
  )
}
